import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@headerhawk/ui";
import { SiteForm } from "@/components/onboarding/site-form";
import { api } from "@/lib/api/client";
import { toast } from "sonner";
import { hostRejectionsOf, type SiteFormData } from "@/lib/validation/site";

interface AddSiteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess: () => void;
}

export function AddSiteDialog({
  open,
  onOpenChange,
  onSuccess,
}: AddSiteDialogProps) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (data: SiteFormData) => {
    setIsSubmitting(true);
    try {
      await api.sites.create(data);
      toast.success("Site created successfully");
      onSuccess();
    } catch (error) {
      // A refused host is shown beside the host field by the form itself.
      if (hostRejectionsOf(error)) throw error;
      const message =
        error instanceof Error ? error.message : "Failed to create site";
      toast.error(message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add Site</DialogTitle>
          <DialogDescription>
            Add a new website to monitor for CSP violations.
          </DialogDescription>
        </DialogHeader>
        <SiteForm
          onSubmit={handleSubmit}
          isSubmitting={isSubmitting}
          submitLabel="Add Site"
        />
      </DialogContent>
    </Dialog>
  );
}
